// LMS Mock Data
// This will eventually be replaced with Supabase queries

// Zoom logo URL for live lectures
export const ZOOM_LOGO_URL = 'https://cdn.shopify.com/s/files/1/0659/6208/2392/files/zoom_logo_icon_147196.png?v=1769335319';

// Default Zoom meeting URL - used when no specific URL is set for a lecture
export const DEFAULT_ZOOM_URL = 'https://us02web.zoom.us/j/87587878805?pwd=W9W6aLGWz8F0oKOjAI3nXLccrawXos.1';

// Item type icons mapping
// Note: 'live-lecture' uses a special Zoom logo image, handled separately in components
export const itemTypeIcons = {
  'start-here': '🚀',
  'about-course': 'ℹ️',
  'video': '🎬',
  'live-lecture': 'zoom', // Special marker - components render Zoom logo image
  'assignment': '📝',
  'quiz': '❓',
  'exam': '📋',
  'workbook': '📚',
  'resource': '🔗',
  'reflection': '💭',
  'lecture': '🎓',
  'pdf': '📄',
  'discussion': '💬',
  'announcement': '📢'
};

// External resources for sidebar
export const externalResources = [
  {
    id: 'facebook',
    title: 'Facebook Community',
    url: 'https://facebook.com/groups/codebreakersnclex',
    icon: '👥',
    description: 'Join our private study group'
  },
  {
    id: 'uworld',
    title: 'UWorld',
    url: 'https://www.uworld.com/nclex/',
    icon: '🌐',
    description: 'Practice questions'
  },
  {
    id: 'passwithpass',
    title: 'Pass with PASS NCLEX Review',
    url: 'https://courses.passwithpass.com/courses/nclex-review-course',
    icon: '✅',
    description: 'Additional review course'
  }
];

// Default module template (6 weeks)
export const defaultModuleTemplate = [
  {
    weekNumber: 1,
    title: 'Week 1: Foundations & Getting Started',
    isVisible: true,
    visibleDate: null,
    items: [
      {
        id: 'w1-start',
        type: 'start-here',
        title: 'Start Here',
        content: 'Welcome to the Code Breakers NCLEX Review! This section will guide you through getting started with the course.',
        order: 1
      },
      {
        id: 'w1-about',
        type: 'about-course',
        title: 'About This Course',
        content: 'This 6-week intensive course is designed to prepare you for NCLEX success through live instruction, practice questions, and comprehensive review materials.',
        order: 2
      },
      {
        id: 'w1-video1',
        type: 'video',
        title: 'Course Introduction & NCLEX Overview',
        videoUrl: '',
        videoType: 'youtube',
        duration: '45 min',
        order: 3
      }
    ]
  },
  {
    weekNumber: 2,
    title: 'Week 2: Fundamentals of Nursing',
    isVisible: true,
    visibleDate: null,
    items: [
      {
        id: 'w2-start',
        type: 'start-here',
        title: 'Start Here - Week 2',
        content: 'This week we dive into nursing fundamentals, the foundation of all patient care.',
        order: 1
      },
      {
        id: 'w2-video1',
        type: 'video',
        title: 'Safety & Infection Control',
        videoUrl: '',
        videoType: 'youtube',
        duration: '60 min',
        order: 2
      },
      {
        id: 'w2-assignment1',
        type: 'assignment',
        title: 'Fundamentals Practice Questions',
        description: 'Complete 50 practice questions on nursing fundamentals.',
        dueDay: 'Friday',
        points: 100,
        order: 3
      }
    ]
  },
  {
    weekNumber: 3,
    title: 'Week 3: Pharmacology',
    isVisible: true,
    visibleDate: null,
    items: [
      {
        id: 'w3-start',
        type: 'start-here',
        title: 'Start Here - Week 3',
        content: 'Pharmacology is heavily tested on NCLEX. This week focuses on medication safety and drug classifications.',
        order: 1
      },
      {
        id: 'w3-video1',
        type: 'video',
        title: 'Medication Administration & Safety',
        videoUrl: '',
        videoType: 'youtube',
        duration: '60 min',
        order: 2
      },
      {
        id: 'w3-quiz1',
        type: 'quiz',
        title: 'Pharmacology Quiz',
        description: 'Test your knowledge of drug classifications.',
        dueDay: 'Thursday',
        points: 50,
        questionCount: 25,
        timeLimit: 30,
        order: 3
      }
    ]
  },
  {
    weekNumber: 4,
    title: 'Week 4: Medical-Surgical Nursing',
    isVisible: false,
    visibleDate: null,
    items: [
      {
        id: 'w4-start',
        type: 'start-here',
        title: 'Start Here - Week 4',
        content: 'Medical-surgical nursing covers the largest portion of NCLEX content.',
        order: 1
      },
      {
        id: 'w4-video1',
        type: 'video',
        title: 'Cardiovascular Disorders',
        videoUrl: '',
        videoType: 'youtube',
        duration: '75 min',
        order: 2
      },
      {
        id: 'w4-video2',
        type: 'video',
        title: 'Respiratory Disorders',
        videoUrl: '',
        videoType: 'youtube',
        duration: '60 min',
        order: 3
      },
      {
        id: 'w4-assignment1',
        type: 'assignment',
        title: 'Med-Surg Case Studies',
        description: 'Analyze patient case studies and answer related questions.',
        dueDay: 'Wednesday',
        points: 150,
        order: 4
      }
    ]
  },
  {
    weekNumber: 5,
    title: 'Week 5: Maternal-Child & Mental Health',
    isVisible: false,
    visibleDate: null,
    items: [
      {
        id: 'w5-start',
        type: 'start-here',
        title: 'Start Here - Week 5',
        content: 'This week covers maternal-child nursing and mental health concepts.',
        order: 1
      },
      {
        id: 'w5-video1',
        type: 'video',
        title: 'Antepartum & Intrapartum Care',
        videoUrl: '',
        videoType: 'youtube',
        duration: '60 min',
        order: 2
      },
      {
        id: 'w5-video2',
        type: 'video',
        title: 'Mental Health Nursing',
        videoUrl: '',
        videoType: 'youtube',
        duration: '45 min',
        order: 3
      },
      {
        id: 'w5-quiz1',
        type: 'quiz',
        title: 'Week 5 Comprehensive Quiz',
        description: 'Test covering maternal-child and mental health content.',
        dueDay: 'Friday',
        points: 75,
        questionCount: 40,
        timeLimit: 45,
        order: 4
      }
    ]
  },
  {
    weekNumber: 6,
    title: 'Week 6: Leadership & Final Review',
    isVisible: false,
    visibleDate: null,
    items: [
      {
        id: 'w6-start',
        type: 'start-here',
        title: 'Start Here - Week 6',
        content: 'Final week! Focus on leadership, delegation, and comprehensive review.',
        order: 1
      },
      {
        id: 'w6-video1',
        type: 'video',
        title: 'Management of Care & Delegation',
        videoUrl: '',
        videoType: 'youtube',
        duration: '60 min',
        order: 2
      },
      {
        id: 'w6-video2',
        type: 'video',
        title: 'Final Review & Test-Taking Strategies',
        videoUrl: '',
        videoType: 'youtube',
        duration: '45 min',
        order: 3
      },
      {
        id: 'w6-exam',
        type: 'exam',
        title: 'Final Comprehensive Exam',
        description: 'Comprehensive exam covering all course content.',
        dueDay: 'Friday',
        points: 300,
        questionCount: 150,
        timeLimit: 180,
        order: 4
      }
    ]
  }
];

// Mock cohorts
export const mockCohorts = [
  {
    id: 'cohort-jan-2025',
    name: 'January 2025 Cohort',
    startDate: '2025-01-06',
    endDate: '2025-02-14',
    status: 'active',
    enrolledCount: 24,
    maxCapacity: 30,
    lectureSchedule: {
      days: ['Monday', 'Wednesday', 'Friday'],
      startTime: '11:30',
      endTime: '15:00',
      timezone: 'EST'
    },
    syllabusPdfs: [
      {
        id: 'pdf-1',
        title: 'Course Syllabus',
        filename: 'NCLEX_Review_Syllabus_Jan2025.pdf',
        uploadedAt: '2025-01-01',
        fileSize: '245 KB'
      },
      {
        id: 'pdf-2',
        title: 'Study Schedule',
        filename: 'Study_Schedule.pdf',
        uploadedAt: '2025-01-01',
        fileSize: '128 KB'
      }
    ]
  },
  {
    id: 'cohort-feb-2025',
    name: 'February 2025 Cohort',
    startDate: '2025-02-17',
    endDate: '2025-03-28',
    status: 'upcoming',
    enrolledCount: 18,
    maxCapacity: 30,
    lectureSchedule: {
      days: ['Monday', 'Wednesday', 'Friday'],
      startTime: '11:30',
      endTime: '15:00',
      timezone: 'EST'
    },
    syllabusPdfs: []
  },
  {
    id: 'cohort-mar-2025',
    name: 'March 2025 Cohort',
    startDate: '2025-03-31',
    endDate: '2025-05-09',
    status: 'upcoming',
    enrolledCount: 8,
    maxCapacity: 30,
    lectureSchedule: {
      days: ['Monday', 'Wednesday', 'Friday'],
      startTime: '11:30',
      endTime: '15:00',
      timezone: 'EST'
    },
    syllabusPdfs: []
  }
];

// Mock users
export const mockUsers = [
  {
    id: 'admin-1',
    email: 'admin@codebreakersnclex.com',
    name: 'Nick Admin',
    role: 'admin',
    status: 'active',
    createdAt: '2024-12-01'
  },
  {
    id: 'student-1',
    email: 'jane.smith@student.edu',
    name: 'Jane Smith',
    role: 'student',
    status: 'active',
    cohortId: 'cohort-jan-2025',
    createdAt: '2025-01-02'
  },
  {
    id: 'student-2',
    email: 'john.doe@student.edu',
    name: 'John Doe',
    role: 'student',
    status: 'active',
    cohortId: 'cohort-jan-2025',
    createdAt: '2025-01-03'
  },
  {
    id: 'student-3',
    email: 'sarah.johnson@student.edu',
    name: 'Sarah Johnson',
    role: 'student',
    status: 'active',
    cohortId: 'cohort-feb-2025',
    createdAt: '2025-01-15'
  },
  {
    id: 'student-4',
    email: 'mike.wilson@student.edu',
    name: 'Mike Wilson',
    role: 'student',
    status: 'inactive',
    cohortId: 'cohort-jan-2025',
    createdAt: '2025-01-04'
  }
];

// Helper function to generate lecture events for a cohort
export const generateLectureEvents = (cohort) => {
  const events = [];
  const startDate = new Date(cohort.startDate);
  const endDate = new Date(cohort.endDate);
  
  // Day mapping (0 = Sunday, 1 = Monday, etc.)
  const dayMap = {
    'Sunday': 0, 'Monday': 1, 'Tuesday': 2, 'Wednesday': 3,
    'Thursday': 4, 'Friday': 5, 'Saturday': 6
  };
  
  const lectureDays = cohort.lectureSchedule.days.map(d => dayMap[d]);
  
  let currentDate = new Date(startDate);
  let weekNumber = 1;
  let lastWeekStart = new Date(startDate);
  
  while (currentDate <= endDate) {
    // Check if we've moved to a new week
    const daysSinceStart = Math.floor((currentDate - startDate) / (1000 * 60 * 60 * 24));
    weekNumber = Math.floor(daysSinceStart / 7) + 1;
    
    if (lectureDays.includes(currentDate.getDay())) {
      events.push({
        id: `lecture-${currentDate.toISOString().split('T')[0]}`,
        type: 'lecture',
        title: `Live Lecture - Week ${weekNumber}`,
        date: currentDate.toISOString().split('T')[0],
        startTime: cohort.lectureSchedule.startTime,
        endTime: cohort.lectureSchedule.endTime,
        cohortId: cohort.id,
        weekNumber: weekNumber,
        isAutoGenerated: true
      });
    }
    
    currentDate.setDate(currentDate.getDate() + 1);
  }
  
  return events;
};

// Helper to generate assignment events from modules
export const generateAssignmentEvents = (cohort, modules) => {
  const events = [];
  const startDate = new Date(cohort.startDate);
  
  const dayMap = {
    'Sunday': 0, 'Monday': 1, 'Tuesday': 2, 'Wednesday': 3,
    'Thursday': 4, 'Friday': 5, 'Saturday': 6
  };
  
  modules.forEach((module, index) => {
    const weekStartDate = new Date(startDate);
    weekStartDate.setDate(startDate.getDate() + (index * 7));
    
    module.items.forEach(item => {
      if (item.dueDay && ['assignment', 'quiz', 'exam'].includes(item.type)) {
        const targetDay = dayMap[item.dueDay];
        const dueDate = new Date(weekStartDate);
        
        // Find the next occurrence of the target day
        while (dueDate.getDay() !== targetDay) {
          dueDate.setDate(dueDate.getDate() + 1);
        }
        
        events.push({
          id: `${item.id}-${cohort.id}`,
          type: item.type,
          title: item.title,
          date: dueDate.toISOString().split('T')[0],
          points: item.points,
          cohortId: cohort.id,
          weekNumber: module.weekNumber,
          moduleItemId: item.id,
          isAutoGenerated: true
        });
      }
    });
  });
  
  return events;
};
